import { property } from '@wonderlandengine/api/decorators.js';
import { Component, Material } from '@wonderlandengine/api';
import { LeatherTypes } from '../../data/configuration.js';

/**
 * Leather Description:
 */
export class LeatherDescription extends Component {
	static TypeName = 'leather-description';

	//-----------------------------------------------------------------------------------------
	// Inspector Variables:
	//-----------------------------------------------------------------------------------------

	@property.string('')
	leatherId: string = '';

	@property.material()
	leatherMaterial: Material | null = null;

	@property.material()
	seatLeatherMaterial: Material | null = null;

	@property.material()
	doorLeatherMaterial: Material | null = null;

	@property.material()
	textileMaterial: Material | null = null;

	@property.material()
	seatTextileMaterial: Material | null = null;

	@property.enum([LeatherTypes[LeatherTypes.TwoTone], LeatherTypes[LeatherTypes.PebbleGrain], LeatherTypes[LeatherTypes.SoftGrain]])
	leatherType!: LeatherTypes;
}
